import React from 'react';
import PropTypes from 'prop-types';
import { BasicForm } from './BasicForm.jsx';
import { FormLabel } from '../FormLabel.jsx';
import { FormErrorMessage } from '../FormErrorMessage.jsx';
import * as textUtil from '../../../../../../utils/textUtil';

export class TextAreaForm extends BasicForm {
  getLabelUtilText (object, input) {
    const { systemMessages } = this.props;
    const { validations: { min_words, max_words } } = object;

    if (min_words && min_words > input.value.length) {
      return `${systemMessages.minimumCharacterCount}: ${textUtil.replaceNumber(systemMessages.characters, min_words)}`;
    }
    else if (max_words) {
      return textUtil.replaceNumber(systemMessages.characters, `${input.value.length}/${max_words}`) ;
    }
    else {
      return ''
    }
  }

  render () {
    const { object, input, meta, disabled } = this.props;
    const { validations: { max_words } } = object;

    return (
      <div className="cu-ui-form-group">
        <FormLabel
          valid={meta.valid}
          label={object.label}
          required={max_words && max_words < input.value.length ? false : object.validations.required}
          utilText={this.getLabelUtilText(object, input)}
        />
        <textarea
          {...input}
          className="cu-ui-input"
          placeholder={object.data.placeholder}
          disabled={disabled}
          onFocus={this.handleFocusInput(input.onFocus)}
          onBlur={this.handleBlurInput(input.onBlur)}
        />
        <FormErrorMessage
          error={meta.error}
          touched={meta.touched}
        />
      </div>
    );
  }
}
